import type { SVGProps } from 'react'
const SvgSyArrowRightCircle = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<g strokeLinejoin="round">
			<path
				fillRule="evenodd"
				d="M12 2C6.487 2 2 6.487 2 12c0 5.514 4.487 10 10 10s10-4.486 10-10c0-5.513-4.487-10-10-10m0 1.5a8.49 8.49 0 0 1 8.5 8.5c0 4.704-3.797 8.5-8.5 8.5A8.49 8.49 0 0 1 3.5 12 8.49 8.49 0 0 1 12 3.5"
				clipRule="evenodd"
				opacity={0.4}
			/>
			<path d="M11.086 7.998a.75.75 0 0 0-1.06.002.75.75 0 0 0 .003 1.06L12.98 12l-2.95 2.94a.75.75 0 0 0-.005 1.06.75.75 0 0 0 1.06.002l3.487-3.47a.75.75 0 0 0 0-1.063z" />
		</g>
	</svg>
)
export default SvgSyArrowRightCircle
